/**
 * interface generic error messages handling in application
 * @packageDocumentation
 * @module ErrorMessageService
 */

import { ErrorWithCode } from "../errors/errors";

/**
 * a record with error messages by lang and code {[lang] : {[errorCode] : errorMessage}}
 */
export type ErrorMessagesRecord<Lang extends string = string> = Record<Lang, Record<number, string>>;

export const ERROR_MESSAGE_SERVICE = "ErrorMessageService";
/**
 * ErrorMessageService interface 
 */
export interface ErrorMessageService<Lang extends string = string> {

    /**
     * Get the error message in the required language from an error response
     * @param error The error object
     * @param lang language wanted for the error message
     */
    getErrorMessage(error: ErrorWithCode, lang?: Lang): Promise<string>;

    /**
     * Save all error messages per code and per Lang (and override messages that are already there)
     * @param codeMessages Contain a message for every response code
     */
    registerErrorMessages(codeMessages: ErrorMessagesRecord<Lang>): void;
}
